import { render } from "./notice.vue?vue&type=template&id=0b62a1f1"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=0b62a1f1&lang=css"
script.render = render

export default script